// Punti in cui le parole lunghe possono andare a capo quando non stanno nello schermo (mobile).
// "|" = punto di rottura. Diventa un soft hyphen: invisibile se la parola ci sta,
// a capo senza trattino se non ci sta (vedi hyphenate-character in index.css).
// Per aggiungere una parola: scrivila qui in maiuscolo con il "|" dove vuoi spezzarla.
const WORDS = [
  'SOLU|TION',
  'SOLU|ZIONE',
  'RACCON|TARE',
  'EMOZIO|NARE',
  'CONVIN|CERE',
  'SITUA|ZIONE',
  'SITUA|ZIONI',
  'SITUA|TION',
  'QUAL|COSA',
  'REAGI|SCONO',
  'OPPOR|TUNITÀ',
  'OPPOR|TUNITY',
  'COMUNI|CATORE',
  'COMMUNI|CATOR',
  'INTER|ESTING',
  'INTERES|SANTI',
  'SOME|THING',
  'SOME|ONE',
  'EXPEC|TED',
  'ASPET|TAVI',
  'QUAL|CUNO',
  'CON|VINCE',
];

const SHY = String.fromCharCode(0xad); // soft hyphen
const RULES = WORDS.map((w) => {
  const cut = w.indexOf('|');
  const word = w.replace('|', '');
  return { re: new RegExp(`(?<![\\p{L}])${word}(?![\\p{L}])`, 'giu'), cut };
});

function breakString(s) {
  return RULES.reduce((acc, { re, cut }) => acc.replace(re, (m) => m.slice(0, cut) + SHY + m.slice(cut)), s);
}

export function withBreaks(node) {
  if (typeof node === 'string') return breakString(node);
  if (Array.isArray(node)) return node.map(withBreaks);
  if (node && typeof node === 'object') {
    return Object.fromEntries(Object.entries(node).map(([k, v]) => [k, k === 'id' || k === 'url' ? v : withBreaks(v)]));
  }
  return node;
}
